/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbFormateurLocalisationDto } from './FcbFormateurLocalisationDto';
import {
    FcbFormateurLocalisationDtoFromJSON,
    FcbFormateurLocalisationDtoFromJSONTyped,
    FcbFormateurLocalisationDtoToJSON,
} from './FcbFormateurLocalisationDto';

/**
 * 
 * @export
 * @interface FcbFormateurLocalisationContratDetailDto
 */
export interface FcbFormateurLocalisationContratDetailDto {
    /**
     * 
     * @type {FcbFormateurLocalisationDto}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    localisation?: FcbFormateurLocalisationDto;
    /**
     * 
     * @type {boolean}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    linkedToMatieres?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    idformateurLocalisationContrat?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    idcontratFormateur?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    idformateurLocalisation?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    dateDebut?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    dateFin?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    heureMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    heureMax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    heureReelle?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    creationUser?: number;
    /**
     * 
     * @type {Date}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    creationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    modificationUser?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    modificationDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    actif?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    dateDebutactivite?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbFormateurLocalisationContratDetailDto
     */
    dateEntreeAuto?: boolean | null;
}

/**
 * Check if a given object implements the FcbFormateurLocalisationContratDetailDto interface.
 */
export function instanceOfFcbFormateurLocalisationContratDetailDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurLocalisationContratDetailDtoFromJSON(json: any): FcbFormateurLocalisationContratDetailDto {
    return FcbFormateurLocalisationContratDetailDtoFromJSONTyped(json, false);
}

export function FcbFormateurLocalisationContratDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurLocalisationContratDetailDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'localisation': !exists(json, 'localisation') ? undefined : FcbFormateurLocalisationDtoFromJSON(json['localisation']),
        'linkedToMatieres': !exists(json, 'linkedToMatieres') ? undefined : json['linkedToMatieres'],
        'idformateurLocalisationContrat': !exists(json, 'idformateurLocalisationContrat') ? undefined : json['idformateurLocalisationContrat'],
        'idcontratFormateur': !exists(json, 'idcontratFormateur') ? undefined : json['idcontratFormateur'],
        'idformateurLocalisation': !exists(json, 'idformateurLocalisation') ? undefined : json['idformateurLocalisation'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'dateDebut': !exists(json, 'dateDebut') ? undefined : (json['dateDebut'] === null ? null : new Date(json['dateDebut'])),
        'dateFin': !exists(json, 'dateFin') ? undefined : (json['dateFin'] === null ? null : new Date(json['dateFin'])),
        'heureMin': !exists(json, 'heureMin') ? undefined : json['heureMin'],
        'heureMax': !exists(json, 'heureMax') ? undefined : json['heureMax'],
        'heureReelle': !exists(json, 'heureReelle') ? undefined : json['heureReelle'],
        'creationUser': !exists(json, 'creationUser') ? undefined : json['creationUser'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (json['creationDate'] === null ? null : new Date(json['creationDate'])),
        'modificationUser': !exists(json, 'modificationUser') ? undefined : json['modificationUser'],
        'modificationDate': !exists(json, 'modificationDate') ? undefined : (json['modificationDate'] === null ? null : new Date(json['modificationDate'])),
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
        'dateDebutactivite': !exists(json, 'dateDebutactivite') ? undefined : (json['dateDebutactivite'] === null ? null : new Date(json['dateDebutactivite'])),
        'dateEntreeAuto': !exists(json, 'dateEntreeAuto') ? undefined : json['dateEntreeAuto'],
    };
}

export function FcbFormateurLocalisationContratDetailDtoToJSON(value?: FcbFormateurLocalisationContratDetailDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'localisation': FcbFormateurLocalisationDtoToJSON(value.localisation),
        'linkedToMatieres': value.linkedToMatieres,
        'idformateurLocalisationContrat': value.idformateurLocalisationContrat,
        'idcontratFormateur': value.idcontratFormateur,
        'idformateurLocalisation': value.idformateurLocalisation,
        'libelle': value.libelle,
        'dateDebut': value.dateDebut === undefined ? undefined : (value.dateDebut === null ? null : value.dateDebut.toISOString()),
        'dateFin': value.dateFin === undefined ? undefined : (value.dateFin === null ? null : value.dateFin.toISOString()),
        'heureMin': value.heureMin,
        'heureMax': value.heureMax,
        'heureReelle': value.heureReelle,
        'creationUser': value.creationUser,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate === null ? null : value.creationDate.toISOString()),
        'modificationUser': value.modificationUser,
        'modificationDate': value.modificationDate === undefined ? undefined : (value.modificationDate === null ? null : value.modificationDate.toISOString()),
        'actif': value.actif,
        'dateDebutactivite': value.dateDebutactivite === undefined ? undefined : (value.dateDebutactivite === null ? null : value.dateDebutactivite.toISOString()),
        'dateEntreeAuto': value.dateEntreeAuto,
    };
}

